import React, { useState } from 'react';
import { ClockIcon, MailIcon, MenuIcon, PhoneIcon, XIcon, CheckIcon } from 'lucide-react';
// Special header for the Tax page that links back to main site
function TaxPageHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className="bg-[#8A9A5B] shadow-sm sticky top-0 z-50" data-id="element-414" data-mp="z16p0cdq07ve">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-415" data-mp="2c7esrtksw0k">
        <div className="flex justify-between items-center py-4" data-id="element-416" data-mp="6d11jhva84rv">
          <div className="flex items-center" data-id="element-417" data-mp="6dj40w8jff88">
            <a href="https://meyerbkt.com" data-id="element-418" data-mp="bcdl9tquwvq8">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mhSQzqAkdBcNMQ8aCTM7Tt/Gray_Logo.png" alt="Meyer Bookkeeping & Tax Logo" className="h-12 w-auto" data-id="element-419" data-mp="baj14hnet7n7" />
            </a>
          </div>
          {/* Desktop navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-420" data-mp="1rosop9jtuscz">
            <a href="https://meyerbkt.com/#services" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-421" data-mp="3fn4zezh1pyq1">
              Services
            </a>
            <a href="https://meyerbkt.com/#process" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-422" data-mp="36mgmy97aw6f9">
              Process
            </a>
            <a href="https://meyerbkt.com/#testimonials" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-423" data-mp="2woaknqhl0y9v">
              Testimonials
            </a>
            <a href="https://meyerbkt.com/#about" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-424" data-mp="2nvz5j0rx4x97">
              About
            </a>
            <a href="https://meyerbkt.com/#faq" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-425" data-mp="2dy1gwc65cyg2">
              FAQ
            </a>
            <a href="https://meyerbkt.com/contact" className="bg-[#3A4A46] text-white px-4 py-2 rounded hover:bg-opacity-80 transition-colors" data-id="element-426" data-mp="291auz87nv8mq">
              Book a Call
            </a>
          </nav>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-427" data-mp="1qch30ayp64va">
            <button onClick={toggleMenu} className="text-white hover:text-gray-200 focus:outline-none" data-id="element-428" data-mp="1ubzmr3es89wj">
              {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-429" data-mp="2i46hxz8ruaud" /> : <MenuIcon className="h-6 w-6" data-id="element-430" data-mp="2n0f2js5qmw8x" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden bg-[#9BAB6C] border-t border-[#79894A]" data-id="element-431" data-mp="2daby8vt61vva">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-432" data-mp="310y7uritjo7e">
            <a href="https://meyerbkt.com/#services" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-433" data-mp="30zer6zt93b53">
              Services
            </a>
            <a href="https://meyerbkt.com/#process" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-434" data-mp="pcb8jo0sggda">
              Process
            </a>
            <a href="https://meyerbkt.com/#testimonials" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-435" data-mp="bdld0ctmaor1">
              Testimonials
            </a>
            <a href="https://meyerbkt.com/#about" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-436" data-mp="l9ob97lcm38p">
              About
            </a>
            <a href="https://meyerbkt.com/#faq" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-437" data-mp="1rqrx7xbj0ek0">
              FAQ
            </a>
            <a href="https://meyerbkt.com/contact" className="block px-3 py-2 text-base font-medium bg-[#3A4A46] text-white rounded" onClick={() => setIsMenuOpen(false)} data-id="element-438" data-mp="6bnev7z19qzs">
              Book a Call
            </a>
          </div>
        </div>}
    </header>;
}
// Special footer for the Tax page that links back to main site
function TaxPageFooter() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-900 text-white py-8" data-id="element-439" data-mp="tzwxk10y9ymp">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-440" data-mp="y1i6xce9zus5">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-441" data-mp="y32yct5amxls">
          <div className="mb-4 md:mb-0" data-id="element-442" data-mp="131wg4xrm5arr">
            <a href="https://meyerbkt.com" data-id="element-443" data-mp="17ywm78ogqdiv">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ftirAgMM8xqTRnsAszCk3U/New_Logo.png" alt="Meyer Bookkeeping & Tax Logo" className="h-10 w-auto" data-id="element-444" data-mp="17zxvp8ptyryh" />
            </a>
          </div>
          <div className="flex flex-col md:flex-row md:space-x-8 text-center md:text-left" data-id="element-445" data-mp="184dp47a59ctv">
            <a href="https://meyerbkt.com/#services" className="text-gray-300 hover:text-white mb-2 md:mb-0" data-id="element-446" data-mp="143lgng93jbyn">
              Services
            </a>
            <a href="https://meyerbkt.com/#process" className="text-gray-300 hover:text-white mb-2 md:mb-0" data-id="element-447" data-mp="1vuhr6a7op4ir">
              Process
            </a>
            <a href="https://meyerbkt.com/#testimonials" className="text-gray-300 hover:text-white mb-2 md:mb-0" data-id="element-448" data-mp="1r1exm22wpv2k">
              Testimonials
            </a>
            <a href="https://meyerbkt.com/#about" className="text-gray-300 hover:text-white mb-2 md:mb-0" data-id="element-449" data-mp="2jlx1oq9m6s53">
              About
            </a>
            <a href="https://meyerbkt.com/#faq" className="text-gray-300 hover:text-white mb-2 md:mb-0" data-id="element-450" data-mp="cxwnoxt801kq">
              FAQ
            </a>
            <a href="https://meyerbkt.com/contact" className="text-gray-300 hover:text-white" data-id="element-451" data-mp="35h641lu5f0d">
              Contact
            </a>
          </div>
        </div>
        <div className="pt-6 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center" data-id="element-452" data-mp="3q955740gnegs">
          <p className="text-gray-400 text-sm" data-id="element-453" data-mp="3vb49qh7xshfb">
            &copy; {currentYear} Meyer Bookkeeping & Tax. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0 flex items-center" data-id="element-454" data-mp="3lbdgeiv448gt">
            <div className="flex space-x-4 items-center" data-id="element-455" data-mp="3ldps4eaa1mlf">
              <a href="https://www.facebook.com/profile.php?id=61578990285219" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white" data-id="element-456" data-mp="1em8isxkoeafi">
                <span className="sr-only" data-id="element-457" data-mp="34086l7x1s7kd">Facebook</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-458" data-mp="2z4982ri09968">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" data-id="element-459" data-mp="39144n4upwzhv" />
                </svg>
              </a>
              <a href="https://www.instagram.com/meyerbookkeeping/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white" data-id="element-460" data-mp="3rpsmtj1tgqpy">
                <span className="sr-only" data-id="element-461" data-mp="1bkyl4zpkck2y">Instagram</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-462" data-mp="1bkf2fgs39rnv">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" data-id="element-463" data-mp="1lb9ytdz1u7n1" />
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/meyer-bookkeeping-tax/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white" data-id="element-464" data-mp="lp1dfimn97ed">
                <span className="sr-only" data-id="element-465" data-mp="qpp4g4avho8l">LinkedIn</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-466" data-mp="qq75rfce6snd">
                  <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" data-id="element-467" data-mp="3u7pf5r7tc7pw" />
                </svg>
              </a>
              <a href="https://www.bible.com/bible/111/1PE.4.NIV" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white ml-4" data-id="element-468" data-mp="31aevn025ukx6">
                1 Peter 4:10
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}
const taxSteps = [{
  title: 'Submit the quote form',
  description: "Send a quick quote request. I'll email you back with two easy ways to get your personalized quote."
}, {
  title: 'Receive your estimate',
  description: "Book a quick call (phone, text, or Teams), or set up your secure TaxDome portal, fill out a short intake form, and upload last year's return. Either way, you'll get a clear, flat-fee quote with no surprises."
}, {
  title: 'Confirm & upload documents',
  description: "Let me know you'd like to move forward, and I'll send your engagement letter to sign in the portal. You'll also get a personalized checklist so you know exactly what to upload."
}, {
  title: 'I prepare and file your return',
  description: "Simple! I prepare your return and send it to you to review. Once you sign the e-file authorization, I file it and let you know when it's accepted."
}];
export function TaxPreparationPage() {
  return <div className="font-sans" data-id="element-469" data-mp="3mmvuoff6t51a">
      <TaxPageHeader data-id="element-470" data-mp="3mo6wi9p2o2pr" />
      {/* Hero Section */}
      <section className="bg-[#F5F7F6] py-16" data-id="element-471" data-mp="3ilaeak3g28mc">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-472" data-mp="3ijh630d6ngc8">
          <div className="text-center max-w-3xl mx-auto" data-id="element-473" data-mp="3dl5v2mb5izsf">
            <h1 className="text-3xl md:text-4xl font-bold text-[#3A4A46] mb-6" data-id="element-474" data-mp="3dnsb7ac3ynm9">
              Tax Preparation Services
            </h1>
            <p className="text-xl text-gray-600" data-id="element-475" data-mp="1buudb03h54ug">
              Professional tax preparation for individuals and small businesses.
              I help you navigate the tax code, maximize deductions, and ensure
              full compliance, while taking the stress out of tax season.
            </p>
          </div>
        </div>
      </section>
      {/* Who I Serve & What's Included */}
      <section className="py-16 bg-white" data-id="element-476" data-mp="1o4a9qoqugfzn">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-477" data-mp="1o5bwvrl4wsxq">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-478" data-mp="1t46dqnzjk7f7">
            {/* Who I Serve */}
            <div data-id="element-479" data-mp="vgy01f5s82nr">
              <h2 className="text-2xl md:text-3xl font-bold text-[#3A4A46] mb-6" data-id="element-480" data-mp="vhg24sf4lb3l">
                Who I Serve
              </h2>
              <ul className="space-y-3" data-id="element-481" data-mp="10hbxk39rbu7j">
                <li className="flex items-start" data-id="element-482" data-mp="15dsvfp6rdmxt">
                  <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0 mt-0.5" data-id="element-483" data-mp="15d11sjwq1za6">
                    •
                  </span>
                  <span className="text-gray-700" data-id="element-484" data-mp="2gt7ssu2vqgtg">Individuals & families</span>
                </li>
                <li className="flex items-start" data-id="element-485" data-mp="2lqr6nsvo0rkv">
                  <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0 mt-0.5" data-id="element-486" data-mp="2jddv6xbuhz7w">
                    •
                  </span>
                  <span className="text-gray-700" data-id="element-487" data-mp="2tcmlng7i4vpi">
                    Contractors / freelancers
                  </span>
                </li>
                <li className="flex items-start" data-id="element-488" data-mp="2obfffll0c4ky">
                  <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0 mt-0.5" data-id="element-489" data-mp="32cjcnohd66nq">
                    •
                  </span>
                  <span className="text-gray-700" data-id="element-490" data-mp="3c2bbiuwhxly0">Small businesses</span>
                </li>
                <li className="flex items-start" data-id="element-491" data-mp="373i15bciab22">
                  <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0 mt-0.5" data-id="element-492" data-mp="3741h4milipdg">
                    •
                  </span>
                  <span className="text-gray-700" data-id="element-493" data-mp="3h2yzt8tcbooj">Rental property owners</span>
                </li>
              </ul>
            </div>
            {/* What's Included */}
            <div data-id="element-494" data-mp="8k6s0oipha4e">
              <h2 className="text-2xl md:text-3xl font-bold text-[#3A4A46] mb-6" data-id="element-495" data-mp="8incj04vj33o">
                What's Included
              </h2>
              <ul className="space-y-3" data-id="element-496" data-mp="3qre4501vb19b">
                <li className="flex items-start" data-id="element-497" data-mp="3vnv20lyvctzl">
                  <CheckIcon className="h-6 w-6 text-[#8A9A5B] mr-3 flex-shrink-0 mt-0.5" data-id="element-498" data-mp="3vmjq1yv9sfxe" />
                  <span className="text-gray-700" data-id="element-499" data-mp="3gxx77n6fp61f">
                    Personal & small business returns
                  </span>
                </li>
                <li className="flex items-start" data-id="element-500" data-mp="37zbvaavgwp9m">
                  <CheckIcon className="h-6 w-6 text-[#8A9A5B] mr-3 flex-shrink-0 mt-0.5" data-id="element-501" data-mp="380mzgbstrz19" />
                  <span className="text-gray-700" data-id="element-502" data-mp="3cyenguqcn106">E-file included</span>
                </li>
                <li className="flex items-start" data-id="element-503" data-mp="2y1xhyk4ucglj">
                  <CheckIcon className="h-6 w-6 text-[#8A9A5B] mr-3 flex-shrink-0 mt-0.5" data-id="element-504" data-mp="32zfqi9ey4tt0" />
                  <span className="text-gray-700" data-id="element-505" data-mp="2jv3u0vp56phs">Secure client portal</span>
                </li>
                <li className="flex items-start" data-id="element-506" data-mp="2f4dqzp46uyq9">
                  <CheckIcon className="h-6 w-6 text-[#8A9A5B] mr-3 flex-shrink-0 mt-0.5" data-id="element-507" data-mp="2f3lu8ayuuuye" />
                  <span className="text-gray-700" data-id="element-508" data-mp="2a6c7j32uoxe9">
                    Optional bookkeeping clean-up{' '}
                    <span className="text-gray-500" data-id="element-509" data-mp="257irp403cuax">(add-on fee)</span>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Pricing */}
      <section className="py-16 bg-[#F5F7F6]" data-id="element-510" data-mp="2xvn0vzhvfpid">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-511" data-mp="2svilydwm32u9">
          <div className="text-center max-w-2xl mx-auto" data-id="element-512" data-mp="2sxv9d6l525ep">
            <h2 className="text-2xl md:text-3xl font-bold text-[#3A4A46] mb-4" data-id="element-513" data-mp="2nvntw713o77m">
              Pricing
            </h2>
            <p className="text-lg text-gray-700" data-id="element-514" data-mp="1hi6m0e3z34dd">
              Returns start at{' '}
              <span className="font-bold text-[#3A4A46]" data-id="element-515" data-mp="1cgr2iqhg15x3">$200</span>, with most
              clients ranging from <span className="font-bold" data-id="element-516" data-mp="3o66wvxp2leti">$275–$600</span>,
              depending on complexity.
            </p>
          </div>
        </div>
      </section>
      {/* How It Works */}
      <section className="py-16 bg-white" data-id="element-517" data-mp="1xe6bwdq71ca">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-518" data-mp="1vkwk87tg102">
          <div className="text-center mb-12" data-id="element-519" data-mp="6p5ww6wvt72f">
            <h2 className="text-2xl md:text-3xl font-bold text-[#3A4A46] mb-4" data-id="element-520" data-mp="6q75m4qfdhgz">
              How It Works
            </h2>
          </div>
          <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8" data-id="element-521" data-mp="foarj25bog9b">
            {taxSteps.map((step, index) => <li key={step.title} className="text-center" data-id="element-522" data-mp="koymfywo9h8t" data-mpi={index}>
                <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[#3A4A46] text-white mb-4 text-2xl font-bold" data-id="element-523" data-mp="pm73fw633f8h">
                  {index + 1}
                </div>
                <h3 className="text-lg font-bold text-[#3A4A46] mb-3" data-id="element-524" data-mp="2rdtozi77ihxk">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-525" data-mp="x56kvw9ziwp7">
                  {step.description}
                </p>
              </li>)}
          </ol>
        </div>
      </section>
      {/* Form & Image Section */}
      <section className="bg-[#F5F7F6] py-16" data-id="element-526" data-mp="16yf279hwv8i7">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-527" data-mp="11yix16xh9b12">
          <div className="text-center mb-8" data-id="element-528" data-mp="e7x30jkb5ra2">
            <h2 className="text-2xl md:text-3xl font-bold text-[#3A4A46] mb-4" data-id="element-529" data-mp="e8omwx4jm0ki">
              Get Your Tax Quote
            </h2>
            <p className="text-lg text-gray-600" data-id="element-530" data-mp="9awwk7jjqmif">
              Fill out the form below to receive a personalized quote for your
              tax preparation needs.
            </p>
          </div>
          <div className="flex flex-col md:flex-row items-center justify-center gap-12" data-id="element-531" data-mp="j92uyf659aij">
            <div className="md:w-1/2 max-w-lg" data-id="element-532" data-mp="1zjez0kc2o1nw">
              <iframe src="https://preview.mailerlite.io/forms/1833129/167250058103752482/share" style={{
              width: '100%',
              height: '500px',
              border: 'none'
            }} title="Tax Preparation Form" data-id="element-533" data-mp="1umok40c07c42"></iframe>
            </div>
            <div className="md:w-1/2 max-w-lg" data-id="element-534" data-mp="1t6sukm51dfgf">
              <img src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1500&q=80" alt="Tax preparation services" className="rounded-lg shadow-lg w-full h-auto" data-id="element-535" data-mp="1x61njos959ax" />
            </div>
          </div>
        </div>
      </section>
      <TaxPageFooter data-id="element-536" data-mp="2g5fkmfla305n" />
    </div>;
}